import React from "react";
import { withState, compose, lifecycle } from "recompose";
import { times } from "ramda";
import styled from "styled-components";
import moment from "moment";

const isAvailable = (availableDays, date) => {
  return availableDays.includes(date.format("ddd"));
};

const getSelectedDay = props =>
  makeDates(props.index).filter(date =>
    isAvailable(props.availableDays, date)
  )[0];

export default compose(
  withState("index", "setIndex", 0),
  withState("date", "setDate", getSelectedDay),
  lifecycle({
    componentDidMount() {
      this.props.onDateChange(this.props.date);
    }
  })
)(({ availableDays, index, date, setIndex, setDate, onDateChange }) => (
  <div>
    <Title>Schedule Your Call</Title>
    <CurrentDate value={date} />
    <SlidesWrap>
      <Arrow
        disabled={index === 0}
        children="chevron_left"
        onClick={() => index > 0 && setIndex(index - 1)}
      />
      <Slides>
        {makeDates(index).map((item, i) => (
          <Date
            key={i}
            value={item}
            isActive={date.isSame(item, "day")}
            isDisabled={!isAvailable(availableDays, item)}
            i={i}
            onClick={date => {
              setDate(date);
              onDateChange(date);
            }}
          />
        ))}
      </Slides>
      <Arrow children="chevron_right" onClick={() => setIndex(index + 1)} />
    </SlidesWrap>
  </div>
));

const makeDates = index => times(i => moment().add(i + index * 7, "days"), 7);

const Date = ({ value, isDisabled, isActive, onClick, i }) => (
  <DateWrap
    isActive={isActive}
    isDisabled={isDisabled}
    onClick={() => !isDisabled && onClick(value)}
    first={i === 0 && !isActive}
    last={i === 6 && !isActive}
  >
    <Day>{value.format("ddd")}</Day>
    <MonthDay>{value.format("D")}</MonthDay>
  </DateWrap>
);

const CurrentDate = ({ value }) => (
  <CurrentDateWrap>{value.format("MMMM")}</CurrentDateWrap>
);

const Day = styled.div`
  font-family: "CircularStd-Book", sans-serif;
`;

const CurrentDateWrap = styled.div`
  margin-bottom: 0.625rem;
  font-family: "CircularStd-Book", sans-serif;
  color: #b0b0b0;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 0.5rem;
  @media (max-width: 680px) {
    text-align: center;
    border: unset;
  }
`;

const DateWrap = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: 0.8rem;
  flex-shrink: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  font-weight: 600;
  padding: 1.25rem 0;
  margin: 0 0.75rem;
  ${({ isDisabled }) =>
    isDisabled &&
    `
    cursor: not-allowed;
    opacity: 0.2;
  `} ${({ isActive }) =>
      isActive &&
      `
    background-color: #f76367;
    color: #fff;
    border-radius: 3px;
  `};
  @media (max-width: 680px) {
    padding: 0.4rem 1.2rem;
  }
  ${({ first, last }) =>
    (first || last) &&
    `
    opacity: .2;
  `};
`;

const MonthDay = styled.div`
  font-size: 1.2rem;
  margin-top: 0.25rem;
`;

const SlidesWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #e5e5e5;
  @media (max-width: 680px) {
    padding: 2rem 0;
    background: #fff;
    border: unset;
    margin-bottom: 3rem;
  }
`;

const Slides = styled.div`
  padding: 0 1rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 680px) {
    padding: unset;
    overflow-y: scroll;
    ::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 2.5rem;
  position: relative;
  top: -2.7rem;
  font-family: TiemposHeadlineWeb;
  font-weight: 400;
  @media (max-width: 680px) {
    display: none;
  }
`;

const Arrow = styled.span.attrs({
  className: "material-icons"
})`
  cursor: pointer;
  font-size: 2rem;
  color: #f76367;
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    color: #e5e5e5;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/ChooseDate/Date.js